<template>
    <div class="modal-card card">
        <form @submit.prevent="onAddProduct()">
        <div class="card-header">
            <div class="catalog-modal-head">
                <span class="catalog-identity-icon"><i class="fa fa-box-open"></i></span>
                <div>
                    <h4 class="card-header-title">Add Product</h4>
                    <p class="catalog-card-subtitle">Version is optional and defaults to 1.</p>
                </div>
            </div>
            <!-- Close -->
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div class="card-body">
                <form-fields :fields="fields" v-model="product" />
                <div v-if="error" class="text-danger">
                    {{error}}
                </div>
        </div>
        <div class="card-footer">
            <div class="d-flex justify-content-end gap-2">
                <button type="button" class="btn btn-white" data-bs-dismiss="modal">Cancel</button>
                <submit-button :fields="fields" v-model="product" />
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import formFields from '../FormFields.vue';
import submitButton from '../SubmitButton.vue'
import {mapActions} from 'vuex';
import Fields from "../../utils/field-constants/productFields";
import { isDuplicate } from '../../utils/commonFunction';
export default {
    components: { formFields, submitButton },
    data(){
        return {
            error: "",
            product: {},
            fields: []
        }
    },
    name: "AddProduct",
    mounted(){
        this.fields= JSON.parse(JSON.stringify(Fields));
        //hiding
        this.fields.map((field)=>{
            if(field.name ==="created_by" || field.name ==="created_at" ||
                field.name ==="updated_by" || field.name ==="updated_at"){
                    field.visible= false
                }
        })
    },
    methods: {
        ...mapActions('admin', {
            createProduct: 'createProduct'
        }),
        async onAddProduct() {
            let valid = true;
            let toastoptions;
            try {
                valid = !isDuplicate(this.product.sku,this.$store.state.admin.products, "sku", null)
                if( valid ){
                    await this.createProduct(this.product);
                    toastoptions = {
                        message: "Product '"+this.product.sku+"' added successfully.",
                        type: "success",
                    };
                }else{
                    toastoptions = {
                            message: "Already '"+this.product.sku+"' sku exits.'",
                            type: "error",
                        };
                }
            } catch (error) {
                if (error.response.data.error) 
                    this.error = error.response.data.error
                else 
                    this.error = error.message
                return
            }
            this.$store.dispatch('addToast', toastoptions);
            if(valid){
                this.$store.dispatch('hideModal');
                this.$store.dispatch('admin/fetchProducts');
            }
        }
    }
};
</script>

<style>
</style>